var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneRingRoundDuotoneLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 60,
    fill: "#21B803"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9997 66.6668L81.7204 82.9573C84.5102 85.0497 88.4412 84.6385 90.7375 82.014L133.333 33.3335",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140 80C140 92.5366 136.073 104.758 128.771 114.949C121.469 125.139 111.158 132.786 99.2864 136.816C87.4151 140.846 74.5797 141.056 62.5829 137.416C50.5861 133.777 40.0306 126.472 32.3988 116.526C24.767 106.58 20.4423 94.493 20.0321 81.9631C19.6219 69.4333 23.1469 57.0896 30.1118 46.6658C37.0768 36.242 47.1319 28.2617 58.865 23.8456C70.5981 19.4296 83.4197 18.7997 95.5291 22.0444",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneRingRoundDuotoneLine);
export default __webpack_public_path__ + "static/media/Done_ring_round_duotone_line.e0448a38ef2d061c4daefeaa7394d506.svg";
export { ForwardRef as ReactComponent };